class scrollHelper{
	constructor() {
		
	}
	init() {
		if (window.location.href.includes('#')) {			
			var hash = window.location.hash;
			var target = $(hash);

			if (target.length) {
				var dest = target.offset().top - 100;
				$("html, body").animate({ scrollTop: dest }, 1500);
			}
		}
	}
	to(el, tar, buff) {
		$(el).click(function (e) {
			e.preventDefault();
			var target = typeof tar === 'undefined' ? $(this).attr('href') : tar,
				buffer = typeof buff === 'undefined' ? 100 : buff,
				scrollDest = parseInt($(target).offset().top - buffer);
			$('html, body').animate({
				scrollTop: scrollDest,
			}, 1000);
		});
	}
	sidenav() {
		var sidenav = $('.right-nav');
		var container = $('.right-container');
		var sidenavTop = $('.right-nav').offset().top - 120;

		if ($(window).width() > 992) {
			$(window).scroll(function(){   

				if ($(window).scrollTop() > sidenavTop) {
					sidenav.addClass('sticky'); 
						if ($(window).scrollTop() >= (container.innerHeight())) {
							sidenav.addClass('bottom');
						} else  {
							sidenav.removeClass('bottom');
						}
				 } else {
					sidenav.removeClass('sticky');
					sidenav.removeClass('bottom');
				}

				var scrollPos = $(this).scrollTop() + 120;

				$('.right-nav a').each(function () {
					var currLink = $(this);
					var refElement = $(currLink.attr("href"));
					if (refElement.position().top <= scrollPos && refElement.position().top + refElement.height() > scrollPos) {
						$('.right-nav li a').removeClass("active");
						currLink.addClass("active");
					}
					else{
						currLink.removeClass("active");
					}
				});
			});
		}
	}
	stickyCTA() {
		var cta = $('.sticky-cta');
		var container = $('.page-content');

		// var observer;
		// var options = {
		// 	root: document.querySelector('.page-content'),
		// 	rootMargin: '0px',
		// 	threshold: 1.0
		// }

		// observer = new IntersectionObserver(() => {
		// 	cta.addClass('sticky');
		// }), options);
		// observer.observe(cta);


		if ($(window).width() > 992) {
			$(window).scroll(function(){   

				if ($(window).scrollTop() > 100) {
					cta.addClass('sticky'); 
						if ($(window).scrollTop() >= (container.innerHeight())) {
							cta.addClass('bottom');
						} else  {
							cta.removeClass('bottom');
						}
				 } else {
					cta.removeClass('sticky');
					cta.removeClass('bottom');
				}


				
			});
		}
	}
	
}
window.app.add('scroll', new scrollHelper());